<script>
    import {actionsStore, openActionPopup} from "./actions-store.js";
    import { t } from '../../core/i18n/language-store';

    function clickHandler() {
        openActionPopup()
    }

</script>

<style>
    .actions-button {
        background: transparent;
        font: inherit;
    }
    .actions-button {
        color: var(--action-btn-text-color);
        border: 1px solid var(--action-btn-border-color);
        text-decoration: none;
        border-radius: 6px;
        padding: .25rem .75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: .5em;
        font-weight: 400;
    }

    .hide-wo-table,
    .hide-wo-table.hide-on-desktop,
    .hide-wo-table.hide-on-mobile {
        display: none !important;
    }
    .hide-on-desktop {
        display: none !important;
    }
    .hide-on-mobile {
        display: inherit;
    }

    @media (max-width: 767px) {
        .hide-on-mobile {
            display: none !important;
        }
        .hide-on-desktop {
            display: inherit !important;
        }
    }

</style>

{#if ($actionsStore.hasActions)}

    <button class="actions-button pointer" on:click={() => clickHandler()}>
        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.75 12H12.375V6.6875C12.375 4.48281 10.7453 2.66094 8.625 2.35781V1.75C8.625 1.40469 8.34531 1.125 8 1.125C7.65469 1.125 7.375 1.40469 7.375 1.75V2.35781C5.25469 2.66094 3.625 4.48281 3.625 6.6875V12H3.25C2.97344 12 2.75 12.2234 2.75 12.5V13C2.75 13.0688 2.80625 13.125 2.875 13.125H6.25C6.25 14.0906 7.03438 14.875 8 14.875C8.96562 14.875 9.75 14.0906 9.75 13.125H13.125C13.1938 13.125 13.25 13.0688 13.25 13V12.5C13.25 12.2234 13.0266 12 12.75 12ZM8 13.875C7.58594 13.875 7.25 13.5391 7.25 13.125H8.75C8.75 13.5391 8.41406 13.875 8 13.875ZM4.75 12V6.6875C4.75 5.81875 5.0875 5.00312 5.70156 4.38906C6.31562 3.775 7.13125 3.4375 8 3.4375C8.86875 3.4375 9.68437 3.775 10.2984 4.38906C10.9125 5.00312 11.25 5.81875 11.25 6.6875V12H4.75Z" fill="currentColor"/>
        </svg>
        {$t('actions.button')}
    </button>

{/if}
